<template>
  <div class="revContainer">
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <!--Table-->
      <b-card-group deck class="mt-3" ref="capture">
        <b-card header-tag="header">
          <template #header>
            <h6 class="mb-0 float-left">Reversion to Mean</h6>
            <downloadChart :commitName="'Mean Reversion'" />
          </template>
          <b-row class="m-0 p-0">
            <b-col sm="7" md="6" class="my-1">
              Show
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
                :style="pageStyle"
              ></b-form-select>
              entries
            </b-col>
            <b-col sm="5" md="6" class="my-1">
              <b-row>
                <b-col>
                  <b-form-select
                    size="sm"
                    v-model="defaultSelected"
                    @change="selectSearchHandler"
                  >
                    <option value="defalutSelectVal">Select</option>
                    <option
                      v-for="item in headersData"
                      v-bind:key="item.label"
                      >{{ item.key }}</option
                    >
                  </b-form-select>
                </b-col>
                <b-col>
                  <b-form-group
                    label-for="filter-input"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-form-input
                      id="filter-input"
                      v-model="filter"
                      type="search"
                      placeholder="Type to Search"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table
                v-if="tblData.length"
                class="mx-auto mt-2"
                :items="tblData"
                :fields="headersData"
                responsive="lg"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                striped
                @filtered="onFiltered"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="5" md="6"></b-col>
            <b-col sm="7" md="6">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>
    </fullscreen>
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <!--Chart-->
      <b-card-group deck class="mt-3" ref="capture1">
        <b-card header-tag="header">
          <template #header>
            <h6 class="mb-0 float-left">
              {{ chartTitle }} on Avg. Reversion to Mean
            </h6>
            <downloadChart :commitName="'Mean Reversion'" />
          </template>
          <b-row class="m-0 p-0">
            <b-col sm="9" md="9" class="p-3">
              <Plotly
                :data="reversionChartData"
                :layout="reversionLayout"
                :display-mode-bar="false"
                :config="config"
                :width="chartWidth"
                :heigt="chartHeight"
                ref="plotlyChart"
              ></Plotly>
            </b-col>
            <b-col sm="3" md="3" class="pr-1 mt-2">
              <div id="checkboxes" class="checkboxesarea">
                <label
                  :for="obj.key"
                  v-for="obj of graphKeyNameList"
                  :key="obj.key"
                  class=""
                >
                  <input
                    type="radio"
                    :value="obj.key"
                    v-model="selectedOption"
                    class="selectCheck"
                    name="mean_reversion_checkbox"
                    @input="selectedValueHandler(obj)"
                  />
                  {{ obj.key }}
                  {{ obj.title }}</label
                >
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Mean_Reversion",
  components: {
    Plotly,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      stockScreens: "stockScreens",
      meanReversion: "meanReversion",
    }),
    stockChildren() {
      // console.log("this.stockScreens---", this.stockScreens);
      return this.stockScreens.child;
    },
    meanReversionTable() {
      return this.meanReversion;
    },
  },
  watch: {
    reversionChartData: {
      deep: true,
      handler: function(newVal) {
        if (this.reversionChartData[0].x.length > 0) {
          let maxVal = Math.max(this.reversionChartData[0].x);
          let minVal = Math.min(this.reversionChartData[0].x);
          this.reversionLayout.xaxis.range[0] = minVal;
          this.reversionLayout.xaxis.range[1] = maxVal;
        }
      },
    },
    meanReversion: {
      deep: true,
      handler: function() {
        this.reversionChartDataHandler("upsidetotargetprice(%)");
      },
    },
  },
  data() {
    return {
      totalRows: 1,
      perPage: 5,
      currentPage: 1,
      chartTitle: "Upside to Target Price (%) ",
      pageOptions: [5, 10, 15, { value: 100, text: "All" }],
      searchApprv: "",
      headersData: [],
      tblData: [],
      pageStyle: "width:50px;padding-right:0",
      filter: null,
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      reversionLayout: {
        title: "",
        width: { default: "100%" },
        height: { default: "100%" },
        autosize: true,
        margin: {
          l: 100,
          r: 0,
          b: 30,
          t: 30,
          pad: 0,
        },
        showlegend: false,
        xaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          fixedrange: true,
          ticks: "outside",
          ticksuffix: "%",
          format: "%",
          range: [-20, 40],
          nticks: 6,
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          fixedrange: true,
        },
      },
      config: { responsive: true },
      isFullScreen: false,
      reversionChartData: [],
      defaultSelected: "defalutSelectVal",
      selected: [
        { title: "Upside to Target Price (%)", key: "upsidetotargetprice(%)" },
      ],
      chartWidth: { default: "100%" },
      chartHeight: { default: "100%" },
      selectedOption: 'upsidetotargetprice(%)',
      graphKeyNameList: [
        {
          title: "Upside to Target Price (%)",
          key: "upsidetotargetprice(%)",
        
        },
        { title: "Mean Reversion", key: "meanreversion" },
        {
          title: "Market Implied EPS growth",
          key: "marketimpliedepsgrowth",
        
        },
        { title: "Net Income (CAGR)", key: "netincome(cagr)" },
        { title: "FCF Yield", key: "fcfyield"},
        {
          title: "PE% above 10% years average",
          key: "pe%above10%yearsaverage",
        
        },
        {
          title: "FY1 Earnings Revision",
          key: "fy1earningsrevision"
        },
        {
          title: "FY1 Earnings Revision (3MMA)",
          key: "fy1earningsrevision(3mma)",
        },
      ],
    };
  },

  mounted() {
    this.reversionChartDataHandler("upsidetotargetprice(%)");
    let filterChart;
    if (
      !window.location.href.includes("auth_token=") &&
      this.meanReversion.length
    ) {
      filterChart = this.stockChildren.filter(
        (item) => "Mean Reversion" === item.objectname
      );
      if (
        typeof filterChart[0].child != "undefined" &&
        filterChart[0].child.length > 0
      ) {
        let tabChild = filterChart[0].child;
        for (var i = 0; i < tabChild.length; i++) {
          this.getChartDataById({
            id: tabChild[i].chartId,
            chartName: tabChild[i].name,
          });
        }
      } else {
        this.getChartDataById({
          id: filterChart[0].chartId,
          chartName: filterChart[0].objectname,
        });
      }
    }
    // console.log("filterChart", filterChart);
    this.setDownloadInfo({
      fileName: "Mean Revesion",
      downloadData: this.$refs.capture,
    });
    // Set the initial number of items
    // this.headerDataFunc();
  },
  methods: {
    ...mapActions([
      "setDownloadInfo",
      "getChartDataById",
      "getIframeChartDataById",
    ]),
    headerDataFunc() {
      // console.log("+++++++++++++");
      this.headersData = [];
      this.tblData = [];
      this.currentPage = 1;
      this.totalRows = this.meanReversionTable.length;
      for (let i = 0; i < this.meanReversionTable.length; i++) {
        let rowData = this.meanReversionTable[i];
        this.tblData.push({
          "Company Name": rowData.companyname,
          Ticker: rowData.ticker,
          "Upside to Target Price (%)": rowData["upsidetotargetprice(%)"],
          "Mean Reversion": rowData.meanreversion,
          "Market Implied EPS growth": rowData.marketimpliedepsgrowth,
          "Net Income (CAGR)": rowData["netincome(cagr)"],
          "FCF Yield": rowData.fcfyield,
          "PE% above 10% years average": rowData["pe%above10%yearsaverage"],
          "FY1 Earnings Revision": rowData.fy1earningsrevision,
          "FY1 Earnings Revision (3MMA)": rowData["fy1earningsrevision(3mma)"],
        });
      }
      let objKeys = Object.keys(this.tblData[0]);
      for (let i = 0; i < objKeys.length; i++) {
        if (
          objKeys[i] != "Stock_Price" &&
          objKeys[i] != "Website_Link" &&
          objKeys[i] != "id"
        ) {
          this.headersData.push({
            key: objKeys[i],
            label: objKeys[i],
            sortable: true,
            sortByFormatted: true,
          });
        }
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async reversionChartDataHandler(filterKey) {
      this.reversionChartData = [
        { x: [], y: [], type: "bar", orientation: "h", marker: { color: [] } },
      ];
      // console.log("this.meanReversion-=-=-", this.meanReversion);
      let chart_API_Data = [];
      if (
        window.location.href.includes("auth_token=") &&
        !this.meanReversion.length
      ) {
        let data = await this.getIframeChartDataById(190);
        chart_API_Data = data;
        // console.log("fedddddddddddd", chart_API_Data);
      } else {
        if (
          this.meanReversion.length &&
          typeof this.meanReversion != "string"
        ) {
          chart_API_Data = JSON.parse(JSON.stringify(this.meanReversion));
        }
      }
      // console.log("reversionChartData+++", chart_API_Data);
      // console.log("this.meanReversion+++", this.meanReversion);
    // console.log("--------------", filterKey);
      for (let i = 0; i < chart_API_Data.length; i++) {
        this.reversionChartData[0].y.push(chart_API_Data[i].ticker);
        this.reversionChartData[0].x.push(chart_API_Data[i][filterKey]);

        if (parseInt(chart_API_Data[i][filterKey]) > 0) {
          this.reversionChartData[0].marker.color.push("rgb(97, 184, 97)");
        } else {
          this.reversionChartData[0].marker.color.push("rgb(199, 9, 8)");
        }
      }
      // console.log("reversionChartData---", reversionChartData);
      // this.reversionChartData;
      this.headerDataFunc();
    },
    // this filter works if user select any value than, then only that column search work
    selectSearchHandler(val) {
      this.filterOn = [];
      this.filterOn.push(val);
    },
    selectedValueHandler(obj) {
      this.selected = [];
      this.selected = [obj];
    // console.log("---------", obj, this.selected);
      this.reversionChartDataHandler(this.selected[0].key);
    },
  },
};
</script>

<style lang="scss">
.revContainer {
  .form-control {
    border: 1px solid silver !important;
    border-radius: 5px !important;
    background: #fff !important;
    font-size: 13px;
    margin-right: 1em;
  }

  .table {
    th {
      vertical-align: middle;
      border-bottom: 2px solid #d0e4f5;
      background: #0b6fa4;
      color: #fff;
      text-align: center;
      font-size: 0.8rem;
    }
    td:first-child {
      text-align: left;
    }
    td {
      input {
        max-width: 110px !important;
        font-size: 11px;
      }

      vertical-align: middle;
      color: #333333;
      font-size: 0.75rem;
      font-family: Arial, sans-serif;
      font-weight: normal;
      padding: 0.25rem;
      text-align: center;
    }

    background: #ffffff;
    // border: 1px solid silver;
    border-collapse: collapse;
  }
  position: relative;
  width: 100%;
  // max-height: 60vh;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 10px;
}

.b-table-sticky-header {
  overflow: auto;
  max-height: 500px !important;
}

thead {
  vertical-align: middle;
  font-weight: bold;
  font-size: 0.9rem;
  background: rgb(177, 217, 243);
  color: rgb(75, 77, 109);
  text-align: center;
  padding: 0.25rem 0.75rem;
}

.pagination {
  float: right;
  margin-right: 1%;
}

.col-form-label {
  font-weight: bold;
}

.tableCell {
  max-width: 100px !important;
}
.checkboxesarea {
  border: 1px solid #eee;
  padding: 5px;
  font-size: 12px;
  font-family: Arial;
  position: relative;
  width: 100%;
  word-break: break-word;
  float: right;
  right: 2%;
  label {
    font-weight: 100;
  }
}
</style>
